module.exports = __webpack_public_path__ + "static/media/img28.69e6953f.jpg";